import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ClerkProvider } from "@clerk/clerk-react";
import App from "App";
import { SoftUIControllerProvider } from "context";
import { AuthProvider } from "auth-context/auth.context";

if (!process.env.REACT_APP_CLERK_PUBLISHABLE_KEY) {
  throw new Error("Missing Clerk Publishable Key");
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <ClerkProvider
      publishableKey={process.env.REACT_APP_CLERK_PUBLISHABLE_KEY}
      appearance={{
        variables: {
          colorPrimary: "#cb0c9f", // Color primario de tu tema
        },
      }}
    >
      <SoftUIControllerProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </SoftUIControllerProvider>
    </ClerkProvider>
  </BrowserRouter>
);
